import type { BrandUser } from "@src/domain/entities/brand";
import type { UpdateBrandUserStatusDTO } from "@src/domain/dto/brands/UpdateBrandUserStatus.dto";
import type { IBrandRepository } from "@src/domain/repositories/brand";

export class UpdateBrandUserStatusUseCase {
  private readonly brandRepository: IBrandRepository;

  constructor(brandRepository: IBrandRepository) {
    this.brandRepository = brandRepository;
  }

  async execute(params: UpdateBrandUserStatusDTO): Promise<BrandUser> {
    try {
      const updatedUser =
        await this.brandRepository.updateBrandUserStatus(params);
      if (!updatedUser) {
        throw new Error("No brand user returned");
      }
      return updatedUser;
    } catch (error) {
      console.error("Failed to update brand user status:", error);
      throw new Error("Failed to update brand user status");
    }
  }
}

